import { COLOR_PRIMARY, COLOR_WHITE } from "#constants/Styles"
import { UsePlanAnualContext } from "#training/contexts/AnnualPlanCreateContext"
import DeleteForeverIcon from "@mui/icons-material/DeleteForever"
import { Stack } from "@mui/material"
import Card from "@mui/material/Card"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import { useCallback, useEffect, useState } from "react"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
export default function AnnualPlanCreateListaCursosDrag() {
	const { cursosIds, setCursosIds, cursos } = UsePlanAnualContext()

	const handleDragEnd = useCallback(
		(result) => {
			if (!result.destination) return
			const newItems = [...cursosIds]
			const [reorderedItem] = newItems.splice(result.source.index, 1)
			newItems.splice(result.destination.index, 0, reorderedItem)
			setCursosIds(newItems)
		},
		[cursosIds, setCursosIds]
	)
	return (
		<DragDropContext onDragEnd={handleDragEnd}>
			<StrictModeDroppable droppableId="lista">
				{(provided) => (
					<div
						style={{
							width: "100%",
						}}
						{...provided.droppableProps}
						ref={provided.innerRef}
					>
						<Stack spacing={1}>
							{cursos
								.filter((item) => cursosIds.includes(item.id))
								.sort(
									(a, b) =>
										cursosIds.indexOf(a.id) - cursosIds.indexOf(b.id)
								)
								.map((item, index) => {
									return (
										<Draggable
											key={item.id}
											draggableId={`${item.id}`}
											index={index}
											isDragDisabled={!(cursosIds.length === 12)}
										>
											{(provided, snapshot) => (
												<Card
													ref={provided.innerRef}
													{...provided.draggableProps}
													{...provided.dragHandleProps}
													style={{
														height: 32,
														...provided.draggableProps.style,
														background: snapshot.isDragging
															? COLOR_PRIMARY
															: "white",
														color: snapshot.isDragging
															? COLOR_WHITE
															: "black",
													}}
												>
													<Stack
														direction={"row"}
														pl={2}
														pr={1}
													>
														<Typography
															variant="poster"
															component="h4"
															align="left"
															style={{
																display: "flex",
																alignItems: "center",
																height: "100%",
																width: "100%",
															}}
														>
															{item.nombre}
														</Typography>
														<ButtonDeleted id={item.id} />
													</Stack>
												</Card>
											)}
										</Draggable>
									)
								})}
						</Stack>
						{provided.placeholder}
					</div>
				)}
			</StrictModeDroppable>
		</DragDropContext>
	)
}

function ButtonDeleted({ id }) {
	const { setCursosIds } = UsePlanAnualContext()
	return (
		<IconButton
			aria-label="delete"
			size="small"
			style={{ color: "red" }}
			onClick={() => {
				setCursosIds((old) => old.filter((item) => item !== id))
			}}
		>
			<DeleteForeverIcon />
		</IconButton>
	)
}

function StrictModeDroppable({ children, ...props }) {
	const [enabled, setEnabled] = useState(false)
	useEffect(() => {
		try {
			const animation = requestAnimationFrame(() => setEnabled(true))
			return () => {
				cancelAnimationFrame(animation)
				setEnabled(false)
			}
		} catch (error) {
			console.error(error)
		}
	}, [])
	if (!enabled) {
		return null
	}
	return <Droppable {...props}>{children}</Droppable>
}
